import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, role}) => {
  const { loading } = useContext(AuthContext);
  const user = JSON.parse(localStorage.getItem("user"));
  
  if (loading) return <div>Loading...</div>;

  // If no user is logged in, redirect to login page
  if (!user) return <Navigate to="/login" />;

  // If user's role is not in allowedRoles, redirect to the home page (or any other page)
  if (role && !role.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return children;

};

export default ProtectedRoute;
